export const SET_CID = "SET_CID";
export const ON_LOAD_CAMPAIGN_DROP_DOWN = "ON_LOAD_CAMPAIGN_DROP_DOWN";
